export default "__VITE_ASSET__C14f57L7__"